import { PublicClientApplication } from "@azure/msal-browser";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { ThemeProvider } from "@mui/material";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";

import { reactPlugin } from "@dfp/react-app-insights";
import { themeRebranding } from "@dfp/react-mui-theme";
import { ReplicatedHistoryProvider } from "@dfp/react-replicated-history";

import App from "./App";
import { ErrorBoundary } from "./Components/ErrorBoundary";
import { AppLanguageProvider } from "./Context/AppLanguage";
import { makeMsalConfig } from "./Features/MSAuthLibrary/makeMsalConfig";
import "./I18n/i18n";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

function initializeMsalInstance(msalInstance: PublicClientApplication) {
  msalInstance.initialize().then(() => {
    // Default to using the first account if no account is active on page load
    if (
      !msalInstance.getActiveAccount() &&
      msalInstance.getAllAccounts().length > 0
    ) {
      // Account selection logic is app dependent. Adjust as needed for different use cases.
      msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]); //
    }

    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      <React.StrictMode>
        <AppInsightsContext.Provider value={reactPlugin}>
          <ErrorBoundary>
            <ThemeProvider theme={themeRebranding}>
              <BrowserRouter>
                <NuqsAdapter>
                  <ReplicatedHistoryProvider>
                    <AppLanguageProvider>
                      <App pca={msalInstance} />
                    </AppLanguageProvider>
                  </ReplicatedHistoryProvider>
                </NuqsAdapter>
              </BrowserRouter>
            </ThemeProvider>
          </ErrorBoundary>
        </AppInsightsContext.Provider>
      </React.StrictMode>,
    );
  });
}

const msalInstance = new PublicClientApplication(makeMsalConfig());
initializeMsalInstance(msalInstance);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
